export default __webpack_public_path__ + "static/media/rotate.8809ae11.svg";